document.addEventListener('DOMContentLoaded', function() {
    // --- バリアント選択時のラベル表示更新 ---
    (() => {
        // 初期表示時に既存のラベルをフォーマット
        document.querySelectorAll('.variant-input-wrap[id^="ProductSelect-"]').forEach(fieldset => {
            if (fieldset.id) {
                const label = document.querySelector(`label.variant__label[for="${fieldset.id}"]`);
                if (label) {
                    formatVariantLabelStructure(label);
                }
            }
        });

        // バリエーションラジオボタンの変更を監視
        const variantContainer = document.querySelector('form.product-form') || document.querySelector('.product-form__variants') || document.body;
        if (variantContainer) {
            variantContainer.addEventListener('change', function(event) {
                const targetRadio = event.target;
                // data-variant-input属性を持つラジオボタンのみを対象
                if (targetRadio.matches('input[type="radio"][data-variant-input]')) {
                    if (targetRadio.checked) {
                        const selectedValue = targetRadio.value;
                        const fieldset = targetRadio.closest('fieldset'); // 親のfieldsetを取得
                        let targetTextLabel = null;
                        if (fieldset && fieldset.id) {
                            // fieldsetに対応するラベルを探す
                            targetTextLabel = document.querySelector(`label.variant__label[for="${fieldset.id}"]`);
                        } else {
                            console.warn('Could not find parent fieldset or fieldset ID for input:', targetRadio);
                        }
                        if (targetTextLabel) {
                            updateCurrentValueText(targetTextLabel, selectedValue); // ラベルのテキストを更新
                        } else {
                            console.warn(`Target text label not found for fieldset id: ${fieldset ? fieldset.id : 'N/A'}.`);
                        }
                    }
                }
            });
        } else {
            console.error('Parent container for variant inputs not found.');
        }
    })();

    // --- 購入方法タブ制御、ポイント表示、関連アプリ連携 ---
    (() => {
        // --- セレクタ定義 ---
        const sealSubscSelector = '.sealsubs-target-element';         // 定期購入アプリのコンテナ
        const allInGiftSelector = '.sns-gift-product-container';    // ギフトアプリのコンテナ
        const pointContainerId = 'vip-product-points-container';      // ポイント表示全体のコンテナID
        const pointValueId = 'vip-product-points-value';            // ポイント数を表示する要素のID
        const priceDisplaySelector = '#product-price-display';        // 価格表示要素のセレクタ
        const buyMethodListSelector = '.buy-method__list';            // 購入方法タブのul要素
        const tabListItemSelector = '.buy-method__listItem';         // 購入方法タブのli要素
        const tabLinkSelector = '.buy-method__listLink';             // 購入方法タブのa要素
        const originalBadgeSelector = '.sls-savings-badge';          // 定期購入の割引バッジ

        // --- 設定 ---
        const tabObserverTargetNode = document.body; // DOM変更監視の対象ノード
        const tabMaxWaitTime = 60000;                // 監視の最大待ち時間 (ミリ秒)

        // --- 状態変数 ---
        let sealSubscElement = null;        // 定期購入アプリの要素
        let allInGiftElement = null;        // ギフトアプリの要素
        let allInGiftWrapper = null;        // ギフトアプリのラッパー要素
        let buyMethodElement = null;        // 購入方法タブのul要素
        let tabLinks = [];                  // 表示中のタブリンク要素のリスト
        let initialSetupDone = false;       // 初回セットアップ（ラッパー移動など）完了フラグ
        let appStatus = { sealFound: false, aigFound: false, aigWrapperFound: false }; // アプリ検出状態

        let initialRequestedTabType = 'normal'; // URLパラメータで最初に要求されたタブタイプ
        let activeTabType = 'normal';          // 現在アクティブ、またはアクティブにしようとしているタブタイプ

        // URLパラメータから初期表示タブタイプを取得
        try {
            const urlParams = new URLSearchParams(window.location.search);
            const initialTabFromUrl = urlParams.get('initial_tab'); // パラメータ名は 'initial_tab'
            const validTabs = ['normal', 'subscription', 'egift'];  // 有効なタブタイプ

            if (initialTabFromUrl && validTabs.includes(initialTabFromUrl)) {
                initialRequestedTabType = initialTabFromUrl;
            } else if (initialTabFromUrl) {
                console.warn(`Invalid value for "initial_tab" URL parameter: ${initialTabFromUrl}`);
            }
        } catch (e) {
            console.error("Error reading URL parameters:", e);
        }
        activeTabType = initialRequestedTabType; // 初期アクティブタブをURLパラメータまたはデフォルト値に設定

        let clonedSavingsBadge = null;      // クローンされた割引バッジ要素
        let badgeObserver = null;           // 割引バッジ監視用のMutationObserver
        let sealSubscElementForBadgeObservation = null; // バッジ監視対象の定期購入アプリ要素

        // 商品価格に基づいてポイントを更新する関数
        function updateProductPoints(newPriceYen) {
            const container = document.getElementById(pointContainerId);
            const displayElement = document.getElementById(pointValueId);
            if (!container || !displayElement) return;

            const vipBasePrice = 100.0; // ポイント計算の基準価格
            const vipBasePoints = 1;    // 基準価格あたりのポイント数
            displayElement.textContent = '-'; // デフォルト表示
            if (typeof newPriceYen !== 'number' || newPriceYen <= 0) return;

            // ★★★★★ ここから修正 ★★★★★
            const rankMultiplier = parseFloat(container.dataset.rankMultiplier || '1.0');
            const saturdayBonusMultiplier = parseFloat(container.dataset.saturdayBonusMultiplier || '0');
            const totalMultiplier = rankMultiplier + saturdayBonusMultiplier;
            // ★★★★★ 修正ここまで ★★★★★

            let productTags = [];
            try {
                productTags = JSON.parse(container.dataset.tags || '[]');
                if (!Array.isArray(productTags)) productTags = [];
            } catch (e) { productTags = []; }

            let highestTagMultiplier = 0;
            productTags.forEach(tag => {
              if (typeof tag === 'string' && tag.includes('vip_points_x')) {
                const multiplier = parseInt(tag.replace('vip_points_x', ''), 10);
                if (!isNaN(multiplier) && multiplier > highestTagMultiplier) highestTagMultiplier = multiplier;
              }
            });
            const productMultiplier = highestTagMultiplier > 0 ? highestTagMultiplier : 1.0;

            let basePoints = 0;
            try {
                // ★★★★★ rankMultiplier を totalMultiplier に変更 ★★★★★
                basePoints = Math.floor(Math.floor((newPriceYen * totalMultiplier) / vipBasePrice) * vipBasePoints);
                if (isNaN(basePoints) || basePoints < 0) basePoints = 0;
            } catch(e) { basePoints = 0; }

            let additionalPoints = 0;
            try {
                const multiplierDifference = productMultiplier >= 2.0 ? productMultiplier - 1.0 : 0;
                if (multiplierDifference > 0) {
                    additionalPoints = Math.floor(Math.floor((newPriceYen * multiplierDifference) / vipBasePrice) * vipBasePoints);
                    if (isNaN(additionalPoints) || additionalPoints < 0) additionalPoints = 0;
                }
            } catch(e) { additionalPoints = 0; }

            const calculatedPoints = basePoints + additionalPoints;
            displayElement.textContent = (calculatedPoints > 0) ? `${Math.floor(calculatedPoints)}` : '-';
        }

        // ギフトアプリのオプション選択をシミュレートする関数
        const clickAigOption = (value) => {
            try {
                const inputElement = document.querySelector(`input.chakra-radio__input[value="${value}"]`);
                if (inputElement) {
                    const labelElement = inputElement.closest('label.chakra-radio');
                    if (labelElement) { labelElement.click(); return true; }
                }
            } catch (error) { console.error(`Error clicking AIG option for value="${value}":`, error); }
            return false;
        };

        // 定期購入アプリのオプション選択をシミュレートする関数
        const clickSealOption = (value) => {
             try {
                 let inputElement = document.querySelector(`input.sls-option[value="${value}"]`);
                 if (!inputElement && value === '0') inputElement = document.querySelector('input.sls-option[data-type="subscription"]');
                 if (inputElement) {
                     const clickableDiv = inputElement.closest('.sls-selling-plan-group-first-line');
                     if (clickableDiv) { clickableDiv.click(); return true; }
                 }
             } catch (error) { console.error(`Error clicking Seal option for value="${value}":`, error); }
             return false;
         };

        // 定期購入割引バッジの監視とクローン作成/管理を行う関数
        const setupBadgeObserver = (targetNode) => {
            if (!targetNode) { // 監視対象がない場合、既存の監視を停止しクローンも削除
                if (badgeObserver) {
                    badgeObserver.disconnect();
                    badgeObserver = null;
                    sealSubscElementForBadgeObservation = null;
                    if (clonedSavingsBadge && clonedSavingsBadge.parentNode) clonedSavingsBadge.parentNode.removeChild(clonedSavingsBadge);
                    clonedSavingsBadge = null;
                }
                return;
            }
            if (badgeObserver && sealSubscElementForBadgeObservation === targetNode) return; // 既に同じ要素を監視中なら何もしない
            if (badgeObserver) badgeObserver.disconnect(); // 以前の監視があれば停止
            sealSubscElementForBadgeObservation = targetNode;

            badgeObserver = new MutationObserver(() => {
                const originalBadge = targetNode.querySelector(originalBadgeSelector);
                if (originalBadge) { // 元のバッジが存在する場合
                    if (!clonedSavingsBadge) { // クローンがなければ作成
                        clonedSavingsBadge = originalBadge.cloneNode(true);
                        if (clonedSavingsBadge.id) clonedSavingsBadge.removeAttribute('id'); // ID重複を避ける
                        clonedSavingsBadge.style.display = 'none'; // 初期非表示
                        updateTabsAndContent(); // タブ更新時に表示を制御
                    } else if (clonedSavingsBadge.innerHTML !== originalBadge.innerHTML) { // 内容が変わっていればクローンも更新
                       clonedSavingsBadge.innerHTML = originalBadge.innerHTML;
                    }
                } else if (clonedSavingsBadge) { // 元のバッジがなくクローンが存在する場合、クローンを削除
                    if (clonedSavingsBadge.parentNode) clonedSavingsBadge.parentNode.removeChild(clonedSavingsBadge);
                    clonedSavingsBadge = null;
                    updateTabsAndContent();
                }
            });
            badgeObserver.observe(targetNode, { childList: true, subtree: true }); // 監視開始
            const initialBadge = targetNode.querySelector(originalBadgeSelector); // 初期チェック
            if (initialBadge && !clonedSavingsBadge) {
                clonedSavingsBadge = initialBadge.cloneNode(true);
                if (clonedSavingsBadge.id) clonedSavingsBadge.removeAttribute('id');
                clonedSavingsBadge.style.display = 'none';


                updateTabsAndContent();
            } else if (!initialBadge && clonedSavingsBadge) {
                if (clonedSavingsBadge.parentNode) clonedSavingsBadge.parentNode.removeChild(clonedSavingsBadge);
                clonedSavingsBadge = null;
                updateTabsAndContent();
            }
        };

        // 定期購入アプリとギフトアプリの存在をチェックし、状態を更新する関数
        const checkAppElements = () => {
            const prevStatus = { ...appStatus }; // チェック前の状態を保持

            // 定期購入アプリのチェック
            const currentSealSubscElement = document.querySelector(sealSubscSelector);
            appStatus.sealFound = !!(currentSealSubscElement && currentSealSubscElement.querySelector('input.sls-option[data-type="subscription"], input.sls-option[value="0"]'));
            if (currentSealSubscElement) setupBadgeObserver(currentSealSubscElement); // バッジ監視を設定/確認
            else setupBadgeObserver(null); // なければ監視停止
            sealSubscElement = currentSealSubscElement;

            // ギフトアプリのチェック
            allInGiftElement = document.querySelector(allInGiftSelector);
            appStatus.aigFound = !!(allInGiftElement && allInGiftElement.querySelector('input.chakra-radio__input[value="eGift"]'));
            if (allInGiftElement) {
                allInGiftWrapper = allInGiftElement.closest('.shopify-block.shopify-app-block') || allInGiftElement.parentElement;
                appStatus.aigWrapperFound = !!allInGiftWrapper;
                if (!allInGiftWrapper) console.warn("AIG Wrapper not found, AIG might not work correctly.");
            } else {
                allInGiftWrapper = null;
                appStatus.aigWrapperFound = false;
            }
            // アプリ状態が変化したか
            const statusChanged = (appStatus.sealFound !== prevStatus.sealFound || appStatus.aigFound !== prevStatus.aigFound || appStatus.aigWrapperFound !== prevStatus.aigWrapperFound);
            return { currentStatus: appStatus, changed: statusChanged };
        };

        // 購入方法タブの表示/非表示、アクティブ状態、コンテンツ表示をまとめて更新する関数
        const updateTabsAndContent = () => {
            let targetTabTypeForThisRun = activeTabType; // 今回の処理で目指すタブタイプ

            // URLで通常以外のタブが要求され、かつ現状そのタブがアクティブでなく、関連アプリが利用可能になった場合、
            // 目指すタブをURLで要求されたものに再設定する
            if (initialRequestedTabType !== 'normal' && activeTabType !== initialRequestedTabType) {
                if (initialRequestedTabType === 'subscription' && appStatus.sealFound) {

                    targetTabTypeForThisRun = initialRequestedTabType;
                } else if (initialRequestedTabType === 'egift' && appStatus.aigFound && appStatus.aigWrapperFound) {
                    targetTabTypeForThisRun = initialRequestedTabType;
                }
            } else if (initialRequestedTabType !== 'normal' && activeTabType === 'normal') { // または、現在通常タブだがURL指定がありアプリが使えるようになった場合
                 if (initialRequestedTabType === 'subscription' && appStatus.sealFound) {
                     targetTabTypeForThisRun = initialRequestedTabType;
                 } else if (initialRequestedTabType === 'egift' && appStatus.aigFound && appStatus.aigWrapperFound) {
                     targetTabTypeForThisRun = initialRequestedTabType;
                 }
             }

            buyMethodElement = document.querySelector(buyMethodListSelector);
            if (!buyMethodElement) { // タブリスト要素自体が見つからない場合
                activeTabType = targetTabTypeForThisRun; // 目指すタブをグローバルに反映試行
                // アプリがないのに対応タブを目指そうとしていたらnormalにフォールバック
                if (!appStatus.sealFound && targetTabTypeForThisRun === 'subscription') activeTabType = 'normal';
                if (!appStatus.aigFound && targetTabTypeForThisRun === 'egift') activeTabType = 'normal';
                updateContentForActiveTab(); // コンテンツ表示のみ試みる
                return;
            }

            const allListItems = Array.from(buyMethodElement.querySelectorAll(tabListItemSelector));
            let visibleTabLinksLocal = []; // この関数スコープ内での表示可能タブリンク
            let subscriptionTabItemElement = null; // 定期購入タブのli要素

            // 各タブの表示/非表示を決定
            allListItems.forEach(item => {
                const tabType = item.dataset.tabType;
                let showTab = false;
                if (tabType === 'normal') showTab = true; // 通常購入タブは常に表示試行
                else if (tabType === 'subscription') { showTab = appStatus.sealFound; if (showTab) subscriptionTabItemElement = item; }
                else if (tabType === 'egift') showTab = appStatus.aigFound && appStatus.aigWrapperFound;

                item.style.display = showTab ? '' : 'none'; // 表示/非表示切り替え
                item.classList.toggle('is-visible', showTab); // 表示状態クラス
                item.classList.remove('active'); // 一旦すべて非アクティブに
                if (showTab) { // 表示するタブならリンクを収集
                    const link = item.querySelector(tabLinkSelector);
                    if (link) visibleTabLinksLocal.push(link);
                }
            });

            // 割引バッジの表示制御
            if (clonedSavingsBadge) {
                clonedSavingsBadge.style.display = 'none'; // デフォルトで非表示
                if (subscriptionTabItemElement && subscriptionTabItemElement.classList.contains('is-visible')) {
                    if (!subscriptionTabItemElement.contains(clonedSavingsBadge)) subscriptionTabItemElement.appendChild(clonedSavingsBadge);
                    clonedSavingsBadge.style.display = ''; // 定期購入タブが表示されていればバッジも表示
                }
            }

            let visibleCount = allListItems.filter(item => item.classList.contains('is-visible')).length;

            // 表示可能なタブが0または1つの場合、タブUIは非表示
            if (visibleCount === 0) { // 表示可能なタブが全くない
                buyMethodElement.style.display = 'none';
                activeTabType = 'normal'; // 通常購入扱い
                updateContentForActiveTab();
                return;
            }
            if (visibleCount === 1) { // 表示可能なタブが1つだけ
                const singleVisibleTab = allListItems.find(item => item.classList.contains('is-visible'));
                if (singleVisibleTab) {
                     allListItems.forEach(item => item.classList.remove('active')); // 他は非アクティブ
                     singleVisibleTab.classList.add('active'); // 唯一の表示タブをアクティブに
                     activeTabType = singleVisibleTab.dataset.tabType; // グローバルなactiveTabTypeを更新
                     buyMethodElement.style.display = 'none'; // タブUIは非表示
                     updateContentForActiveTab();
                     return;
                }
            }

            // 表示可能なタブが2つ以上の場合、タブUIを表示
            buyMethodElement.style.display = 'flex';

            // ギフトアプリのラッパー要素をタブの後に移動 (初回のみ)
            if (appStatus.aigFound && appStatus.aigWrapperFound && !initialSetupDone && allInGiftWrapper && buyMethodElement.parentNode && allInGiftWrapper.parentNode !== buyMethodElement.parentNode) {
                try { buyMethodElement.parentNode.insertBefore(allInGiftWrapper, buyMethodElement.nextSibling); } catch(e) { console.error("AIG wrapper move error:", e); }
            }

            // タブクリックイベントリスナーを再設定
            tabLinks.forEach(link => link.removeEventListener('click', handleTabClick)); // 既存のリスナーを削除
            visibleTabLinksLocal.forEach(link => link.addEventListener('click', handleTabClick)); // 新しいリスナーを追加
            tabLinks = visibleTabLinksLocal; // グローバルなtabLinksリストを更新

            // アクティブにするタブを決定
            let intendedActiveTabType = targetTabTypeForThisRun;
            let activeTabListItem = null;

            activeTabListItem = allListItems.find(item => item.dataset.tabType === intendedActiveTabType && item.classList.contains('is-visible'));

            if (!activeTabListItem) { // 意図したタブが表示されていない場合、フォールバック
                intendedActiveTabType = 'normal'; // まず通常購入タブを試す
                activeTabListItem = allListItems.find(item => item.dataset.tabType === intendedActiveTabType && item.classList.contains('is-visible'));
                if (!activeTabListItem && visibleTabLinksLocal.length > 0) { // 通常購入もダメなら、最初の表示可能タブ
                    activeTabListItem = visibleTabLinksLocal[0].closest(tabListItemSelector);
                    if (activeTabListItem) {
                        intendedActiveTabType = activeTabListItem.dataset.tabType;
                    }
                }
            }

            // 最終的なアクティブタブを設定
            if (activeTabListItem) {
                activeTabListItem.classList.add('active');
                activeTabType = intendedActiveTabType; // グローバルなactiveTabTypeを更新
            } else { // フォールバックでもアクティブタブが見つからない場合（通常は起こらないはず）
                activeTabType = 'normal'; // 最終手段として通常購入に
                const normalTabFallbackItem = allListItems.find(item => item.dataset.tabType === 'normal' && item.classList.contains('is-visible'));
                if (normalTabFallbackItem) normalTabFallbackItem.classList.add('active');
            }

            updateContentForActiveTab(); // タブに対応するコンテンツを表示
            initialSetupDone = true; // 初回セットアップ完了
        };

        // アクティブなタブに基づいて、対応するアプリの表示/非表示とオプション選択を行う関数
        const updateContentForActiveTab = () => {
             sealSubscElement = document.querySelector(sealSubscSelector); // 最新の要素を取得
             allInGiftElement = document.querySelector(allInGiftSelector); // 最新の要素を取得
             if (allInGiftElement) allInGiftWrapper = allInGiftElement.closest('.shopify-block.shopify-app-block') || allInGiftElement.parentElement;
             else allInGiftWrapper = null;

             // まず両方のアプリ要素を非表示に
             if (sealSubscElement) sealSubscElement.style.display = 'none';
             if (allInGiftWrapper) allInGiftWrapper.style.display = 'none';

              switch (activeTabType) {
                  case 'normal': // 通常購入
                      if (appStatus.aigFound) clickAigOption('none');         // ギフトは「なし」
                      if (appStatus.sealFound) clickSealOption('one_time');  // 定期は「一回のみ」
                      break;
                  case 'subscription': // 定期購入
                      if (appStatus.sealFound && sealSubscElement) sealSubscElement.style.display = 'block'; // 定期購入アプリ表示
                      else if (!appStatus.sealFound) console.warn("Tried to show subscription content, but sealFound is false.");
                      if (appStatus.aigFound) clickAigOption('none');
                      if (appStatus.sealFound) clickSealOption('0'); // 定期購入オプション選択
                      break;
                  case 'egift': // ギフト
                      if (appStatus.aigFound && appStatus.aigWrapperFound && allInGiftWrapper) allInGiftWrapper.style.display = 'block'; // ギフトアプリ表示
                      else if (!appStatus.aigFound || !appStatus.aigWrapperFound) console.warn("Tried to show egift content, but aigFound/wrapper is false.");
                      if (appStatus.aigFound) clickAigOption('eGift');    // ギフトオプション選択
                      if (appStatus.sealFound) clickSealOption('one_time');


                      break;
                  default: // 未対応のタブタイプの場合は通常購入として扱う
                      activeTabType = 'normal'; // activeTabTypeを安全な値に
                      if (appStatus.aigFound) clickAigOption('none');
                      if (appStatus.sealFound) clickSealOption('one_time');
              }
         };

        // タブクリック時の処理
        const handleTabClick = (event) => {
            event.preventDefault();
            const clickedLink = event.currentTarget;
            const clickedListItem = clickedLink.closest(tabListItemSelector);
            if (!clickedListItem) return; // クリックされた要素の親liが見つからなければ何もしない

            const clickedTabType = clickedListItem.dataset.tabType;
            // すでにアクティブなタブ、または同じタブタイプがクリックされた場合は何もしない
            if (clickedListItem.classList.contains('active') || clickedTabType === activeTabType) return;

            activeTabType = clickedTabType; // グローバルなactiveTabTypeを更新

            // 他のタブのactiveクラスを削除し、クリックされたタブにactiveクラスを付与
            const allTabsInList = clickedListItem.parentNode.querySelectorAll(tabListItemSelector);
            allTabsInList.forEach(item => item.classList.toggle('active', item === clickedListItem));

            setTimeout(updateContentForActiveTab, 50); // コンテンツ更新（少し遅延させることでアプリ側の描画待機）
        };

        // 価格変更を監視し、ポイント表示を更新
        const priceElement = document.querySelector(priceDisplaySelector);
        if (priceElement) {
            const priceObserver = new MutationObserver(() => {
                try {
                    const priceText = priceElement.textContent || '';
                    const newPrice = parseFloat(priceText.replace(/[^0-9.]/g, ''));
                    if (!isNaN(newPrice) && newPrice > 0) updateProductPoints(newPrice);
                    else { const el = document.getElementById(pointValueId); if (el) el.textContent = '-'; }
                } catch (e) { console.error('Error processing price change for points update:', e); }
            });
            priceObserver.observe(priceElement, { childList: true, subtree: true, characterData: true });
        } else console.warn(`VIP Points: Price element ("${priceDisplaySelector}") not found.`);

        // --- アプリの遅延ロード対応のためのMutationObserver ---
        let tabObserver = null;
        let tabObserverTimeout = null;
        let finalized = false; // 監視終了フラグ
        const finalize = () => { // 監視を停止し、タイムアウトをクリアする関数
            if (finalized) return;
            finalized = true;
            if (tabObserver) tabObserver.disconnect();
            if (tabObserverTimeout) clearTimeout(tabObserverTimeout);
        };

        // --- 初期化処理 ---
        checkAppElements(); // 最初にアプリの状態を確認
        updateTabsAndContent(); // タブとコンテンツの初期表示

        // 全てのアプリが揃っていない場合はDOMの変更監視を開始
        if (!(appStatus.sealFound && appStatus.aigFound && appStatus.aigWrapperFound)) {
             tabObserver = new MutationObserver(() => {
                 if (finalized) { if (tabObserver) tabObserver.disconnect(); return; } // 既に終了していれば何もしない
                  const checkResult = checkAppElements(); // DOM変更時にアプリの状態を再チェック
                  if (checkResult.changed) { // アプリの状態が変わっていたらタブとコンテンツを更新
                       updateTabsAndContent();
                        if (appStatus.sealFound && appStatus.aigFound && appStatus.aigWrapperFound) { // 全て揃ったら監視終了
                             finalize();
                         }
                  }
             });
             tabObserver.observe(tabObserverTargetNode, { childList: true, subtree: true }); // 監視開始
             // 指定時間後に監視を強制終了するタイムアウト
             tabObserverTimeout = setTimeout(() => {
                 checkAppElements(); // タイムアウト時にも最終状態を確認
                 updateTabsAndContent();
                 finalize();
             }, tabMaxWaitTime);
         }
    })();

    // --- 日付フォーマット処理 ---
    (() => {
        const targetSpanId = 'cc-shortest-date';        // フォーマット対象の日付が入ったspanのID
        const formattedSpanId = targetSpanId + '-formatted'; // フォーマット後の日付を入れる新しいspanのID
        const dateObserverTargetNode = document.body;   // DOM監視対象
        const shortestDisplayTargetId = 'cc-shortest';    // 表示を監視したい要素のID
        const classToAdd = 'is-visible';               // 付け外ししたいクラス名

        const formatJapaneseDate = (dateString) => {
             if (!dateString || !dateString.includes('-')) return null;
             try {
                 const parts = dateString.split('-');
                 if (parts.length === 3) {
                     const month = parseInt(parts[1], 10);
                     const day = parseInt(parts[2], 10);
                     if (!isNaN(month) && !isNaN(day)) return `<span>${month}</span>月<span>${day}</span>日`;
                 }
             } catch (error) { console.error(`Error parsing date string "${dateString}":`, error); }
             return null;
         };

        const processDateSpan = () => {
            const originalSpan = document.getElementById(targetSpanId);
            if (!originalSpan) return;
            const originalText = originalSpan.textContent.trim();
            const formattedDateHtml = formatJapaneseDate(originalText);
            if (formattedDateHtml) {
                let formattedSpan = document.getElementById(formattedSpanId);
                if (!formattedSpan) {
                    formattedSpan = document.createElement('span');
                    formattedSpan.id = formattedSpanId;
                    formattedSpan.style.cssText = originalSpan.style.cssText;
                    if (originalSpan.parentNode) {
                        originalSpan.parentNode.insertBefore(formattedSpan, originalSpan.nextSibling);
                        if (originalSpan.style.display !== 'none') originalSpan.style.display = 'none';
                    } else { return; }
                }
                if (formattedSpan.innerHTML !== formattedDateHtml) {
                    formattedSpan.innerHTML = formattedDateHtml;
                }
            } else if (originalText && !originalText.includes('-')) {
                 const existingFormattedSpan = document.getElementById(formattedSpanId);
                 if (existingFormattedSpan) existingFormattedSpan.style.display = 'none';
                 if (originalSpan.style.display === 'none') originalSpan.style.display = 'block';
            }
        };

        const checkShortestDisplayAndAddClass = () => {
            const targetElement = document.getElementById(shortestDisplayTargetId);

            // 要素がないか、すでにクラスが付いている場合は、何もしない
            if (!targetElement || targetElement.classList.contains(classToAdd)) {
                return;
            }

            // displayが'block'の場合のみ、クラスを追加する
            if (window.getComputedStyle(targetElement).display === 'block') {
                targetElement.classList.add(classToAdd);
            }
        };

        // --- Observerのコールバック ---
        const dateObserver = new MutationObserver(() => {
            processDateSpan(); // 元々の処理
            checkShortestDisplayAndAddClass(); // ★ 更新した関数を呼び出す
        });

        dateObserver.observe(dateObserverTargetNode, { childList: true, subtree: true, characterData: true });

        // --- 初期チェック ---
        processDateSpan(); // 元々の初期チェック
        checkShortestDisplayAndAddClass(); // ★ 更新した関数を呼び出す
    })();

    // --- アコーディオン機能 ---
    (() => {
        function openAccordion(item, trigger, contentWrapper) {
            if (trigger.getAttribute('aria-expanded') === 'true' || item.dataset.animating === 'true') return;
            item.dataset.animating = 'true';
            item.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
            contentWrapper.setAttribute('aria-hidden', 'false');
            const scrollHeight = contentWrapper.scrollHeight;
            requestAnimationFrame(() => {
                contentWrapper.style.maxHeight = `${scrollHeight}px`;
                contentWrapper.style.opacity = '1';
                contentWrapper.addEventListener('transitionend', () => {
                    item.dataset.animating = 'false';
                }, { once: true });
            });
        }

        function closeAccordion(item, trigger, contentWrapper, isPeek) {
            if (trigger.getAttribute('aria-expanded') === 'false' || item.dataset.animating === 'true') return;
            item.dataset.animating = 'true';
            const peekHeight = '10em';
            const targetHeight = isPeek ? peekHeight : '0px';
            const targetOpacity = isPeek ? '1' : '0';
            contentWrapper.style.maxHeight = `${contentWrapper.scrollHeight}px`;
            requestAnimationFrame(() => {
                trigger.setAttribute('aria-expanded', 'false');
                contentWrapper.setAttribute('aria-hidden', 'true');
                item.classList.remove('is-open');
                contentWrapper.style.maxHeight = targetHeight;
                contentWrapper.style.opacity = targetOpacity;
                contentWrapper.addEventListener('transitionend', () => {
                    item.dataset.animating = 'false';
                }, { once: true });
            });
        }

        document.querySelectorAll('.product-info-accordion .accordion-item.show-peek').forEach(item => {
            const contentWrapper = item.querySelector('.accordion-content-wrapper');
            const trigger = item.querySelector('.accordion-trigger');
            if (contentWrapper && trigger && trigger.getAttribute('aria-expanded') === 'false') {
                contentWrapper.style.maxHeight = '10em';
                contentWrapper.style.opacity = '1';
            }
        });

        document.querySelectorAll('.product-info-accordion .accordion-item').forEach(item => {
            const trigger = item.querySelector('.accordion-trigger');
            const contentId = trigger?.getAttribute('aria-controls');
            const contentWrapper = contentId ? document.getElementById(contentId) : null;
            if (!trigger || !contentWrapper) {
                console.warn('Accordion trigger or content wrapper not found for item:', item);
                return;
            }
            const isPeek = item.classList.contains('show-peek');
            trigger.addEventListener('click', () => {
                const isOpen = trigger.getAttribute('aria-expanded') === 'true';
                if (isPeek) {
                    if (isOpen) closeAccordion(item, trigger, contentWrapper, true);
                    else openAccordion(item, trigger, contentWrapper);
                } else {
                    if (isOpen) closeAccordion(item, trigger, contentWrapper, false);
                    else openAccordion(item, trigger, contentWrapper);
                }
            });
            if (isPeek) {
                item.addEventListener('click', (event) => {
                    if (event.target.closest('.accordion-trigger')) return;
                    if (trigger.getAttribute('aria-expanded') === 'false') {
                        openAccordion(item, trigger, contentWrapper);
                    }
                });
            }
        });
    })();

    // --- SP時の画像スライダーカウンター表示 ---
    (() => {
        const mobileBreakpoint = 768;
        const isMobile = window.innerWidth <= mobileBreakpoint;
        const counterElement = document.querySelector('.product-gallery__counter');

        if (isMobile) {
            const productGallerySlider = document.querySelector('.product-slideshow');
            let mediaCount = 0;
            if (productGallerySlider) {
                mediaCount = productGallerySlider.querySelectorAll('.product-main-slide')?.length || 0;
            }

            if (mediaCount > 1 && productGallerySlider && counterElement) {
                const currentSlideElement = counterElement.querySelector('.current-slide');
                const totalSlidesElement = counterElement.querySelector('.total-slides');
                if (currentSlideElement && totalSlidesElement) {
                    setTimeout(() => {
                        const flkty = Flickity.data(productGallerySlider);
                        if (flkty) {
                            totalSlidesElement.textContent = flkty.slides.length;
                            const updateCounter = () => { currentSlideElement.textContent = flkty.selectedIndex + 1; };
                            flkty.on('settle', updateCounter);
                            updateCounter();
                        } else {
                            console.error('Flickity instance not found for mobile counter.');
                        }
                    }, 150);
                } else {
                     console.error('Counter span elements (.current-slide or .total-slides) not found.');
                 }
            } else if (counterElement) {
                counterElement.style.display = 'none';
            }
        } else if (counterElement) {
            counterElement.style.display = 'none';
        }
    })();

    // ★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★
    // ★★★ バリエーションごとの状態変化に対応した最終版 ★★★
    // ★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★
    (() => {
        console.log('--- chouchou-shop.jp カスタムスクリプト初期化 ---');

        const mainForm = document.querySelector('form.product-single__form');
        const mainAddToCart = document.querySelector('[data-add-to-cart]');
        const cartSticky = document.querySelector('.cart-sticky');
        const stickyButton = document.querySelector('.js-sticky-cart-btn');

        if (!mainForm || !mainAddToCart || !cartSticky || !stickyButton) {
            console.error('必須要素が見つからないため、処理を中断します。');
            return;
        }

        const stickySelect = document.querySelector('.variant-selector-sticky');
        const mainSelect = document.querySelector('[data-product-select]');
        const stickyButtonText = stickyButton.querySelector('.sticky-cart-btn__text');

        console.log('必須要素の取得完了');

        const checkProductAndApplyLogic = () => {
            console.log('%c[判定開始] 商品状態の判定を開始します。', 'color: blue; font-weight: bold;');
            try {
                const variantJsonText = document.querySelector('[data-variant-json]')?.textContent;
                if (!variantJsonText) return;

                const allVariants = JSON.parse(variantJsonText);

                // ▼▼▼【重要変更点】▼▼▼
                // 現在選択されているバリアントのIDを取得する
                const currentVariantId = mainSelect.value;
                // 全バリアントの中から、現在選択されているバリアントの情報を探す
                const currentVariant = allVariants.find(v => v.id == currentVariantId);
                // ▲▲▲【重要変更点】▲▲▲

                if (!currentVariant) {
                    console.error('現在選択中のバリアント情報が見つかりません。');
                    return;
                }
                console.log('現在選択中のバリアント:', currentVariant);

                const sellingPlans = currentVariant.selling_plan_allocations || [];
                const isPreOrderProduct = sellingPlans.length > 0 && (sellingPlans[0].price === sellingPlans[0].compare_at_price);

                console.log(`判定結果: isPreOrderProduct = ${isPreOrderProduct}`, {
                    sellingPlansLength: sellingPlans.length,
                    price: sellingPlans[0]?.price,
                    compare_at_price: sellingPlans[0]?.compare_at_price
                });

                if (isPreOrderProduct) {
                    console.log('→ 予約商品の処理を実行します。');
                    handlePreOrderProduct(currentVariant);
                } else {
                    console.log('→ 通常・定期商品の処理を実行します。');
                    handleNormalProduct();
                }

                if (!cartSticky.dataset.variantsInitialized && stickySelect && allVariants.length > 1) {
                    initializeVariantSelector(allVariants);
                    cartSticky.dataset.variantsInitialized = 'true';
                } else if (!cartSticky.dataset.variantsInitialized && stickySelect) {
                    stickySelect.style.display = 'none';
                    cartSticky.dataset.variantsInitialized = 'true';
                }

            } catch (e) {
                console.error('[エラー] 判定処理中にエラーが発生しました:', e);
                mainAddToCart.style.visibility = 'visible';
            }
        };

        const handlePreOrderProduct = (variant) => {
            console.log('%c[予約処理] handlePreOrderProduct実行', 'color: red;');
            // 予約アプリ(Timesact)のDOM書き換えは他アプリのボタンと衝突して当てにならないため、
            // Selling Planの判定結果を使って自分でラベルを確定させる。
            const textEl = mainAddToCart.querySelector('[data-add-to-cart-text]');
            if (textEl && variant.available) {
                textEl.textContent = '予約注文';
            }
            mainAddToCart.style.visibility = 'visible';
            console.log('  > ボタンを「予約注文」表示にして表示しました。');
        };

        const handleNormalProduct = () => {
            console.log('%c[通常処理] handleNormalProduct実行', 'color: green;');
            const textEl = mainAddToCart.querySelector('[data-add-to-cart-text]');
            if (textEl && textEl.dataset.defaultText) {
                textEl.textContent = textEl.dataset.defaultText;
            }
            mainAddToCart.style.visibility = 'visible';
            console.log('  > メインボタンを表示状態にしました (visibility: visible)');
        };

        const initializeVariantSelector = (variants) => {
            stickySelect.innerHTML = '';
            variants.forEach(variant => {
                const option = document.createElement('option');
                option.value = variant.id;
                option.textContent = variant.title;
                if (!variant.available) option.disabled = true;
                stickySelect.appendChild(option);
            });
            if (mainSelect?.value) stickySelect.value = mainSelect.value;
        };


        // ─────────────────────────────────────────────
        // 置き換え後の sticky 同期ロジック
        const syncStickyElements = () => {
        const mainBtnStyle = window.getComputedStyle(mainAddToCart);
        const isMainBtnVisible = mainBtnStyle.display !== 'none' && mainBtnStyle.visibility !== 'hidden';
        cartSticky.classList.toggle('cart-sticky-active', isMainBtnVisible);

        const soldOut = !!mainAddToCart.disabled;

        // 活性/非活性
        const shouldDisable = soldOut;
        stickyButton.disabled = shouldDisable;
        stickyButton.classList.toggle('is-disabled', shouldDisable);

        // 文言の出し分け
        const mainText = (mainAddToCart.textContent || '').trim() || 'カートに入れる';
        let btnTextToShow = mainText;               // 基本はメインと同じ
        if (soldOut) btnTextToShow = '売切れ';      // 在庫0のみ「売切れ」
        /*if (consentBlocked) btnTextToShow = 'カートに入れる'; // 未同意は常に「カートに入れる」*/

        if (stickyButtonText) { stickyButtonText.textContent = btnTextToShow; }
        else { stickyButton.textContent = btnTextToShow; }
        };

        // --- イベントリスナーを設定 ---
        checkProductAndApplyLogic();

        mainForm.addEventListener('change', (event) => {
            // Shopifyのバリアント変更イベントはフォームのchangeイベントで検知できる
            if (event.target.name === 'id' || event.target.matches('[data-variant-input]')) {
                console.log('[イベント] バリエーション変更を検知。50ms後に再判定を実行します。');
                setTimeout(checkProductAndApplyLogic, 50);
            }
        });

        const syncObserver = new MutationObserver(syncStickyElements);
        syncObserver.observe(mainAddToCart, { attributes: true, childList: true, subtree: true, characterData: true });

        syncStickyElements();

        if(stickySelect){
            stickySelect.addEventListener('change', () => {
                if (mainSelect) {
                    mainSelect.value = stickySelect.value;
                    // メインのセレクトのchangeイベントを能動的に発火させる
                    mainSelect.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });
        }

        stickyButton.addEventListener('click', () => {
            if (!mainAddToCart.disabled) {
                mainAddToCart.click();
            }
        });

    })();


    // ===============================
    // 定期タブ時のみボタン文言変更
    // ===============================
    (() => {

    const AGREED_TEXT = '定期条件に同意しカートに入れる';
    const SUB_TAB_SEL = '.buy-method__listItem[data-tab-type="subscription"]';

    const isSubscriptionActive = () => {
        const li = document.querySelector(SUB_TAB_SEL);
        return !!(li && li.classList.contains('active'));
    };

    const updateCartText = () => {

        const subActive = isSubscriptionActive();

        // メインボタン
        const mainBtn = document.querySelector('[data-add-to-cart]');
        if (mainBtn && !mainBtn.disabled) {
        if (subActive) {
            mainBtn.textContent = AGREED_TEXT;
        } else {
            if (!mainBtn.textContent.includes('予約')) {
            mainBtn.textContent = 'カートに入れる';
            }
        }
        }

        // スティッキー
        const stickyBtn = document.querySelector('.js-sticky-cart-btn');
        if (stickyBtn && !stickyBtn.disabled) {
        if (subActive) {
            stickyBtn.textContent = AGREED_TEXT;
        } else {
            stickyBtn.textContent = 'カートに入れる';
        }
        }
    };

    // タブ切替監視
    const observer = new MutationObserver(updateCartText);
    observer.observe(document.body, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
    });

    // 初回実行
    updateCartText();

    })();
});


// --- グローバル関数 ---

// バリアントラベルの表示を整形する関数
// 例：「オプション名： 商品名 現在の値」を「オプション名： **商品名** 現在の値」のようにする
function formatVariantLabelStructure(labelElement) {
    const outerSpan = labelElement.querySelector('span.variant__label-option-name');
    const valueSpan = labelElement.querySelector('span.variant__label-option-currentValue');
    if (!outerSpan || !valueSpan || outerSpan.classList.contains('js-label-formatted')) return; // 必要な要素がないか、既に処理済みなら何もしない

    let mainTextWithOption = '';
    if (outerSpan.firstChild && outerSpan.firstChild.nodeType === Node.TEXT_NODE) {
        mainTextWithOption = outerSpan.firstChild.textContent.trim(); // "オプション名： 商品名" の部分
    }

    const parts = mainTextWithOption.split('：'); // コロンで分割
    if (parts.length > 1) {
      const optionName = parts[0].trim(); // "オプション名"
      const mainText = parts[1].trim();   // "商品名"
      // HTML構造を再構築して太字化
      outerSpan.innerHTML = `${optionName}： <strong class="variant-label__main-text--bold">${mainText}</strong><span class="variant__label-option-currentValue">${valueSpan.textContent.trim()}</span>`;
      outerSpan.classList.add('js-label-formatted'); // 処理済みマーカー
    } else {
      console.warn('"：" not found in the main text part of the label:', labelElement);
    }
  }

// バリアントラベルの現在選択されている値を更新する関数
function updateCurrentValueText(labelElement, selectedValue) {
    const valueSpan = labelElement.querySelector('.variant__label-option-currentValue');
    if (valueSpan) valueSpan.textContent = ' ' + selectedValue; // 値を更新（先頭にスペース）
    else console.warn('Current value span (.variant__label-option-currentValue) not found inside label during update:', labelElement);
  }
